// SketchDashboard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import FavouriteButton from './FavouriteButton';

import plusIcon from './assets/plus-button.png';
import workerIcon from './assets/worker.png';
import robotIcon from './assets/robot.png';
import scheduleIcon from './assets/schedule.png';
import addschedIcon from './assets/addsched.png';
import engadminIcon from './assets/engadmin.png';
import printerIcon from './assets/printer.png';
import checkedIcon from './assets/checked.png';


const MaintenanceDashboard = () => {
  const navigate = useNavigate();

    // Navigation Handlers
    const handleNavigation = (route) => {
      navigate(route);
    };
  
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
        {/* Favorite Button */}
        <FavouriteButton pageUrl={window.location.pathname} />
  
        {/* Page Title */}
        <h1 className="text-4xl font-semibold text-gray-800 mb-8">Maintenance Manager Dashboard</h1>
  
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-5xl">
          <Tile title="Create a new machine (PPM)" icon={plusIcon} onClick={() => handleNavigation("/PPMAssetCreate")} />
          <Tile title="Manage existing machines" icon={robotIcon} onClick={() => handleNavigation("/PPMAssetsList")} />
          <Tile title="Manage Engineers" icon={workerIcon} onClick={() => handleNavigation("/PPMEngineersAdmin")} />
          <Tile title="Schedule Jobs" icon={addschedIcon} onClick={() => handleNavigation("/PPMScheduleJobs")} />
          <Tile title="View the Schedule" icon={scheduleIcon} onClick={() => handleNavigation("/PPMDailySchedule")} />
          <Tile title="Engineer Portal" icon={engadminIcon} onClick={() => handleNavigation("/PPMEngineerPortal")} />
          <Tile title="Print Schedule" icon={printerIcon} onClick={() => handleNavigation("/PPMPrintSchedule")} />
          <Tile title="Completed Jobs" icon={checkedIcon} onClick={() => handleNavigation("/PPMCompletedJobs")} />
          <Tile title="Export PPM (by month)" icon={checkedIcon} onClick={() => handleNavigation("/PPMExport")} />
        </div>
      </div>
    );
  };

// ✅ Reusable Tile Component
const Tile = ({ title, icon, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition cursor-pointer transform hover:-translate-y-1 flex flex-col items-center justify-center text-center w-full h-48 border border-gray-200"
    >
      <div className="flex justify-center items-center w-20 h-20 bg-gray-200 rounded-full group-hover:bg-primary transition">
        <img src={icon} alt={title} className="h-10 w-10 object-contain" />
      </div>
      <p className="mt-4 text-lg font-semibold text-gray-800 group-hover:text-primary transition">{title}</p>
    </div>
  );
};

export default MaintenanceDashboard;
